import React from 'react';
import { Button } from 'ui';
import { useModals } from '~/contexts/ModalsContext';

interface Props {}

const ListFlowVariationsAddOptionButton: React.FC<Props> = () => {
  const modals = useModals();
  return (
    <Button
      onClick={() => modals.openModal('variationsModal', {})}
      variant="outlined"
      color="grey"
      className="h-10"
    >
      Add an Option
    </Button>
  );
};

export default ListFlowVariationsAddOptionButton;
